<div class="row">
  <div class="col-lg-4 col-md-6 col-sm-12 d-flex" *ngFor="let user of users">
    <div class="card mb-4" app-user [user]="user" [userType]="userType" (onDelete)="onDelete($event)"
      (onSeeInventars)="onSeeInventars($event)" (onUnassign)="onUnassign.emit(user)" [filialId]="filialId" (onSeeFilials)="onSeeFilials($event)"></div>
  </div>
</div>